import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ConfigProvider, Spin } from 'antd';
import 'react-toastify/dist/ReactToastify.css';
import 'animate.css/animate.min.css';
import 'utils/yupUtils';
import { useDidUpdate } from 'rooks';
import { isNil } from 'lodash';
import 'react-quill/dist/quill.snow.css';

import {
  ALERT_TOASTER_OPTIONS,
  BASE_ALERTS_CONTAINER_ID,
} from 'utils/toastUtils';
import AppLayout from 'components/AppLayout';
import { ANTD_CONFIG } from 'constants/AntdConfig';
import { startUserLiveChat, startVisitorLiveChat } from 'libs/Intercom';
import { getUserDetails } from 'redux/reducers/authenticationSlice';
import NotificationSocketProvider from 'features/notification/NotificationSocketProvider';
import PopupNotificationContainer from 'features/notification/PopupNotificationContainer';
import ApprovedEntityPopupContainer from 'features/notification/ApprovedEntityPopupContainer';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { activeRoleSelector, userSelector } from 'redux/selectors/authenticationSelectors';

import './styles/App.less';


function App() {
  const dispatch = useAppDispatch();
  const [isAuthDataLoaded, setIsAuthDataLoaded] = useState(false);
  const activeRole = useAppSelector(activeRoleSelector);
  const user = useAppSelector(userSelector);

  const loadUserDetails = async () => {
    await dispatch(getUserDetails());
  };

  useDidUpdate(()=>{
    !isNil(user) && startUserLiveChat(user, activeRole);
  },[activeRole])

  useEffect(() => {
    const loadInitialData = async () => {
      await loadUserDetails();

      setIsAuthDataLoaded(true);
    };

    if (localStorage.getItem('jwt-token')) {
      loadInitialData();
    } else {
      startVisitorLiveChat();
      setIsAuthDataLoaded(true);
    }
    // eslint-disable-next-line
  }, [dispatch]);

  if (!isAuthDataLoaded) {
    return <Spin size="large" spinning={true} />;
  }

  return (
    <>
      <NotificationSocketProvider>
        <ConfigProvider {...ANTD_CONFIG}>
          <Router>
            <AppLayout />

            <ApprovedEntityPopupContainer />

            <PopupNotificationContainer />

            <ToastContainer
              enableMultiContainer
              {...ALERT_TOASTER_OPTIONS}
              containerId={BASE_ALERTS_CONTAINER_ID}
            />
          </Router>
        </ConfigProvider>
      </NotificationSocketProvider>
    </>
  );
}

export default App;
